
import React, { useEffect, useState } from 'react';
import AOS from 'aos';
import page_json from './config/config.json'
import { Helmet } from 'react-helmet';
import ContactUsButton from './ContactUsButton';
import HeroComponent from './HeroComponent';
import SuccessStoriesList from './SuccessStoriesList';
import config from '../config';

const textDataUrl = `${page_json.page_jsons.AiDataServices}?v=${config.VERSION}`;
const textDataResponse = await fetch(textDataUrl);
const textData = await textDataResponse.json();

function AiDataServices() {
	useEffect(() => {
		AOS.init(); // Initialize AOS
	}, []);
	const [activePanel, setActivePanel] = useState(null);
	const togglePanel = (panelId) => {
		setActivePanel(activePanel === panelId ? null : panelId);
	};
	var left_index = 0;
	return (
		<div data-aos="fade-up" className="aiAndDataPage">
			<Helmet>
        <meta name="description" content="Building integral models with AI and Data for your success and surge." />
        <title>AI and Data | Services | Engineersmind</title>
      </Helmet>
			<HeroComponent
        bgImageMobile={textData.layer1.mobilebannerimg}
        bgImage={textData.layer1.img}
        textContent={
          <h1>
            {textData.layer1.heading1}
              <br />
            <span>
              {textData.layer1.heading2}
            </span>
          </h1>
        }
        breadcrumbs={
          <ol className="breadcrumb">
            <li className="breadcrumb-item"><a href="/">Home </a></li>
            <li className="breadcrumb-item"><a href="/Services/Digital-Transformation">Services </a></li>
            <li className="breadcrumb-item active" aria-current="page">AI & Data</li>
          </ol>
        }
      />
      <div className="container full-height-section sub-header-section">
        <div className="container">
          <div className="row sub-header-row">
            <div className="col-lg-6 col-md-12 col-sm-12 col-xs-12">
              <div className="content-container d-flex flex-column justify-content-center h-100">
                <h4 className="mb-4">{textData.introduction.heading}</h4>
                <p className="mb-4">{textData.introduction.body.text1}</p>
                <p className="mb-4">{textData.introduction.body.text2}</p>
                <p className="mb-4">{textData.introduction.body.text3}</p>
              </div>
            </div>
            <div className="col-lg-6 col-md-12 col-sm-12 col-xs-12 d-flex align-items-center">
              <div className="image-container d-flex justify-content-center">
                <img
                  src={textData.introduction.img}
                  className="img-fluid rounded-3 "
                  alt="industry"
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="container-fluid ModernPortals">
        <div className="container">
          <h1 className="mb-0">
            <span>{textData.dataintegrationandmanagement.heading}</span>
          </h1>
          &nbsp;
          <div className="row">
            <div className="col-lg-5 col-md-12 col-sm-12 col-xs-12 row-section-img  d-flex justify-content-start align-items-center">
              <img
                src={textData.dataintegrationandmanagement.img}
                className="img-fluid ModernPortals-left-img"
                alt="Resilient_solutions"
              />
            </div>
            <div className="col-lg-7 col-md-12 col-sm-12 col-xs-12  d-flex  align-items-center">
              <div className="portal text-20">
                <p className="pb-4 text-20">
                  {textData.dataintegrationandmanagement.body.text1}
                </p>
                <p className="pb-4 text-20">
                  {textData.dataintegrationandmanagement.body.text2}
                </p>
                <p className="pb-4 text-20">
                  {textData.dataintegrationandmanagement.body.text3}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="container-fluid ModernPortals second">
        <div className="container">
          <h1 className="mb-0">
            <span>{textData.datalakes.heading}</span>
          </h1>
          &nbsp;
          <div className="row row-section">
            <div className="col-lg-7 col-md-12 col-sm-12 col-xs-12  d-flex  align-items-center">
              <div className="portal text-20">
                <p className="pb-4 text-20">{textData.datalakes.body.text1}</p>
                <p className="pb-4 text-20">{textData.datalakes.body.text2}</p>
                <p className="pb-4 text-20">{textData.datalakes.body.text3}</p>
              </div>
            </div>
            <div className="row-section-img col-lg-5 col-md-12 col-sm-12 col-xs-12 row-section d-flex justify-content-end align-items-center">
              <img
                src={textData.datalakes.img}
                className="img-fluid ModernPortals-left-img2"
                alt="Resilient_solutions"
              />
            </div>
          </div>
        </div>
      </div>

      <div className="container-fluid ModernPortals third">
        <div className="container">
          <h1 className="mb-0">
            <span>{textData.enhanceddatainsights.heading}</span>
          </h1>
          &nbsp;
          <div className="p-0 text-20">
            <p>{textData.enhanceddatainsights.body.text1}</p>&nbsp;
          </div>
          <div className="row full-stack">
            <div className="col-lg-5 col-md-12 col-sm-12 col-xs-12 full-stack row-section-img  d-flex justify-content-start align-items-center">
              <img
                src={textData.enhanceddatainsights.img}
                className="img-fluid ModernPortals-left-img2"
                alt="Resilient_solutions"
              />
            </div>
            <div className="col-lg-7 col-md-12 col-sm-12 col-xs-12  d-flex  align-items-center">
              <div className="portal list-item">
                {textData.enhanceddatainsights.keyFeatures.map(
                  (feature, index) => {
                    return (
                      <div className="d-flex w-100 list-item" key={index}>
                        <img
                          src={textData.bulletPoints.img}
                          alt="bullet-point"
                        />
                        <div>
                          <p className="fst-italic text-20">
                            <strong>{feature.title}</strong>
                          </p>
                          <p className="portal-desc text-20">
                            {feature.description}
                          </p>
                        </div>
                      </div>
                    );
                  }
                )}
              </div>
            </div>
          </div>
          <div className="pt-4 text-20">
            <p>{textData.enhanceddatainsights.body.text2}</p>
          </div>
        </div>
      </div>

      <div className="container-fluid ModernPortals second">
        <div className="container">
          <h1 className="mb-0">
            <span>{textData.rowlevelsecurity.heading}</span>
          </h1>
          &nbsp;
          <div className="row row-section">
            <div className="col-lg-7 col-md-12 col-sm-12 col-xs-12  d-flex  align-items-center">
              <div className="portal text-20">
                <p className="pb-4 text-20">
                  {textData.rowlevelsecurity.body.text1}
                </p>
                <p className="pb-4 text-20">
                  {textData.rowlevelsecurity.body.text2}
                </p>
              </div>
            </div>
            <div className="col-lg-5 col-md-12 col-sm-12 col-xs-12 row-section-img row-section  d-flex justify-content-end align-items-center">
              <img
                src={textData.rowlevelsecurity.img}
                className="img-fluid ModernPortals-left-img2"
                alt="Resilient_solutions"
              />
            </div>
          </div>
        </div>
      </div>

      <div className="container ModernPortals full-height-section">
        <h1>{textData.predectiveanalytics.heading}</h1>
        <p
          className="text-20 mb-4"
          dangerouslySetInnerHTML={{ __html: textData.predectiveanalytics.text }}
        />
        <div className="row portal predectiveAnalyticsSection">
          {textData.predectiveanalytics.points.map((point, index) => {
            return (
              <div className="d-flex w-100 list-item  pb-3" key={index}>
                <img src={point.img} alt="bullet-point" />
                <div>
                  <h4 className="mb-2">{point.title}</h4>
                  <p className="portal-desc text-20">{point.description1}</p>
                  {point.description2 && (
                    <p className="portal-desc text-20">{point.description2}</p>
                  )}
                </div>
              </div>
            );
          })}
        </div>
      </div>

      <div className="container-fluid ModernPortals third">
        <div className="container">
          <h1 className="mb-0">
            <span>{textData.chatbotsandvirtualassistants.heading}</span>
          </h1>
          &nbsp;
          <div className="p-0 text-20">
            <p>{textData.chatbotsandvirtualassistants.body.text1}</p>&nbsp;
          </div>
          <div className="row full-stack">
            <div className="col-lg-5 col-md-12 col-sm-12 col-xs-12 full-stack  row-section-img d-flex justify-content-start align-items-center">
              <img
                src={textData.chatbotsandvirtualassistants.img}
                className="img-fluid ModernPortals-left-img2"
                alt="Resilient_solutions"
              />
            </div>
            <div className="col-lg-7 col-md-12 col-sm-12 col-xs-12  d-flex  align-items-center">
              <div className="portal list-item">
                {textData.chatbotsandvirtualassistants.keyFeatures.map(
                  (feature, index) => {
                    return (
                      <div className="d-flex w-100 list-item" key={index}>
                        <img
                          src={textData.bulletPoints.img}
                          alt="bullet-point"
                        />
                        <div>
                          <p className="fst-italic text-20">
                            <strong>{feature.title}</strong>
                          </p>
                          <p className="portal-desc text-20">
                            {feature.description}
                          </p>
                        </div>
                      </div>
                    );
                  }
                )}
              </div>
            </div>
          </div>
          <div className="pt-4 text-20">
            <p>{textData.chatbotsandvirtualassistants.body.text2}</p>
          </div>
        </div>
      </div>

      <div className="container-fluid ModernPortals second">
        <div className="container">
          <h1 className="mb-0">
            <span>{textData.aimodelsandsolutions.heading}</span>
          </h1>
          &nbsp;
          <div className="p-0 text-20">
            <p>{textData.aimodelsandsolutions.body.text1}</p>&nbsp;
          </div>
          <div className="row full-stack row-section">
            <div className="col-lg-7 col-md-12 col-sm-12 col-xs-12  d-flex  align-items-center">
              <div className="portal list-item">
                {textData.aimodelsandsolutions.keyFeatures.map(
                  (feature, index) => {
                    return (
                      <div className="d-flex w-100 list-item" key={index}>
                        <img
                          src={textData.bulletPoints.img}
                          alt="bullet-point"
                        />
                        <div>
                          <p className="fst-italic text-20">
                            <strong>{feature.title}</strong>
                          </p>
                          <p className="portal-desc text-20">
                            {feature.description}
                          </p>
                        </div>
                      </div>
                    );
                  }
                )}
              </div>
            </div>
            <div className="col-lg-5 col-md-12 col-sm-12 col-xs-12 full-stack row-section-img  d-flex justify-content-end align-items-center">
              <img
                src={textData.aimodelsandsolutions.img}
                className="img-fluid ModernPortals-left-img2"
                alt="Resilient_solutions"
              />
            </div>
          </div>
          <div className="pt-4 text-20">
            <p>{textData.aimodelsandsolutions.body.text2}</p>
          </div>
        </div>
      </div>

      <SuccessStoriesList StoriesList={textData.storiesList} />

      <div className="container full-height-section sub-header-section">
        <div className="container">
          <h1>
            <span>{textData.conclusion.heading}</span>
          </h1>
          <div className="row">
            <div className="col-lg-6 col-md-12 col-sm-12 col-xs-12 d-flex align-items-center">
              <div className="image-container d-flex justify-content-center align-items-center p-4">
                <img
                  src={textData.conclusion.img}
                  className="img-fluid rounded-3"
                  alt="industry"
                />
              </div>
            </div>
            <div className="col-lg-6 col-md-12 col-sm-12 col-xs-12">
              <div className="content-container d-flex flex-column justify-content-center h-100">
                <p className="mb-4 text-20">{textData.conclusion.body.text1}</p>
                <p className="mb-4 text-20">{textData.conclusion.body.text2}</p>
                <p className="mb-4 text-20">{textData.conclusion.body.text3}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AiDataServices;
